import z from "zod";
import {
  ReviewStateArray,
  ReviewStateLabelMap,
  ReviewTypeArray,
  ReviewTypeLabelMap,
} from "@/constants";

export const reviewSearchSchema = z.object({
  page: z.number().min(1).default(1).catch(1),
  pageSize: z.number().min(1).max(100).default(20).catch(20),
  sortBy: z
    .enum(["createdAt", "queueEnteredAt", "priorityQueue", "status", "type"])
    .default("createdAt")
    .catch("createdAt"),
  sortOrder: z.enum(["asc", "desc"]).default("desc").catch("desc"),
  filter: z
    .enum([...ReviewStateArray, "all"])
    .default("all")
    .catch("all"),
  type: z
    .enum([...ReviewTypeArray, "all"])
    .default("all")
    .catch("all"),
});

export type ReviewSearchParams = z.infer<typeof reviewSearchSchema>;

export const reviewStatusItems = [
  { value: "all", label: "全部" },
  ...ReviewStateArray.map((status) => ({ value: status, label: ReviewStateLabelMap[status] })),
];

export const reviewTypeItems = [
  { value: "all", label: "全部" },
  ...ReviewTypeArray.map((type) => ({ value: type, label: ReviewTypeLabelMap[type] })),
];
